export default "__VITE_ASSET__fXhUYbt___"